const AppConstants = {
	//API:'http://api.901ridechoice.com',
	//Base_Url: 'http://api.901ridechoice.com',

	//For SSH URLS
	//API:'https://www.901ridechoice.com/api',
	//Base_Url: 'https://www.901ridechoice.com',

	//For NEW SSH URLS
	// API:'https://api.901ridechoice.com',
	// Base_Url: 'https://901ridechoice.com',

	//  API:'http://api.localhost:2020',
	//  Base_Url: 'http://localhost:3000',    

	// API:'http://mt3api.ebiz.digital',
	// Base_Url: 'https://mt3admin.ebiz.digital',  

	API:'https://api.mt3health.com',
	Base_Url: 'https://admin.mt3health.com',  
	
	//API:'http://stagingapi.901ridechoice.com',
	//Base_Url: 'http://stagingadmin.901ridechoice.com',    
    }
export default AppConstants